/**
 * Aplica máscara de telefone no formato (XX) XXXXX-XXXX.
 * @param {string|null} val - valor bruto (com ou sem formatação)
 * @returns {string}
 */
export function applyPhoneMask(val) {
  const v = String(val || '').replace(/\D/g, '').slice(0, 11)
  if (!v) return ''
  if (v.length <= 2) return '(' + v
  if (v.length <= 7) return '(' + v.slice(0, 2) + ') ' + v.slice(2)
  return '(' + v.slice(0, 2) + ') ' + v.slice(2, 7) + '-' + v.slice(7)
}

/**
 * Formata um valor numérico para exibição em inputs (sem símbolo R$).
 * Ex: 1500 → "1.500,00"
 * @param {number|string|null} value - valor em reais (float)
 * @returns {string}
 */
export function formatAmountInput(value) {
  const n = parseFloat(value) || 0
  return n === 0 ? '' : n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

/**
 * Formata um valor numérico como moeda brasileira com símbolo R$.
 * Ex: 1500 → "R$ 1.500,00"
 * @param {number|string|null} value - valor em reais (float)
 * @returns {string}
 */
export function formatCurrency(value) {
  const n = parseFloat(value) || 0
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

/**
 * Aplica máscara de valor monetário em tempo real (centavos da direita para esquerda).
 * Ex: digitando "5000" → "50,00"; "150000" → "1.500,00"
 * @param {string} inputValue - valor atual do input (pode conter caracteres não-numéricos)
 * @returns {string} valor formatado no padrão brasileiro
 */
export function applyMoneyMask(inputValue) {
  const digits = String(inputValue || '').replace(/\D/g, '').slice(0, 13)
  if (!digits) return ''
  const cents = parseInt(digits, 10)
  const value = cents / 100
  return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

/**
 * Converte string mascarada em formato brasileiro para número.
 * Ex: "1.234,56" → 1234.56; "" ou null → null
 * @param {string|null} masked
 * @returns {number|null}
 */
export function parseMaskedMoney(masked) {
  if (!masked) return null
  const cleaned = String(masked).replace(/\./g, '').replace(',', '.')
  const val = parseFloat(cleaned)
  return isNaN(val) ? null : val
}

/**
 * Quebra uma descrição de histórico de alteração ("Campo: valor antigo →
 * valor novo", uma por linha — ver buildChangeDescription em
 * routes/accounts.js e buildAppointmentChangeDescription em
 * routes/appointments.js) em objetos prontos pra exibir num timeline.
 * Linhas sem "rótulo: antigo → novo" (ex: "Observações atualizadas") viram
 * `{ raw: line }`.
 * @param {string|null} description
 * @returns {Array<{label: string, old: string, next: string} | {raw: string}>}
 */
export function parseHistoryDescription(description) {
  if (!description) return []
  return description.split('\n').map(line => {
    const arrowIdx = line.indexOf(' → ')
    if (arrowIdx === -1) return { raw: line }
    const colonIdx = line.indexOf(': ')
    if (colonIdx === -1) return { raw: line }
    return {
      label: line.slice(0, colonIdx),
      old: line.slice(colonIdx + 2, arrowIdx),
      next: line.slice(arrowIdx + 3),
    }
  })
}
